/**
 * THE MATCH — the clock, and how it ended.
 *
 * The endings are the AUTHORITY's (`RoundMsg.winner`, `reason`); this only puts them into words. A screen
 * that worked out its own result would be §0.1.3 with the outcome as its object.
 */
export default {
  // The banner, by how the round ended. Two axes — won or lost, and why — because "you won" and "you won
  // on the clock" are different things to the player who was about to be overrun.
  won: 'YOU WON',
  won_timeout: 'YOU WON · ON TIME',
  // NOT "eliminated": a body comes back after `conf.bots.playerOutS`, so that word names a state the game
  // no longer has. What this line reports is how the ROUND ended, and it pairs with `won` above.
  lost: 'YOU LOST',
  timeout: "TIME'S UP",
  draw: 'DRAW',
  captured_won: 'FLAG CAPTURED',
  captured_lost: 'FLAG LOST',
  objective_done: 'MISSION COMPLETE',
  objective_failed: 'MISSION FAILED',
  // The end-of-round card. Four cells and not a sentence: they are compared against the last match, and a
  // number inside a line of prose has to be found before it can be read.
  // The end table's column heads: short, because they head a column of numbers.
  col_kills: 'Kills',
  col_downs: 'Down',
  stat_enemies: 'Enemies down',
  stat_kills: 'Kills',
  stat_downs: 'Times down',
  stat_time: 'Time',
  again: 'Play again',
  again_btn: 'New match',
  // The counter beside the clock: how many of the opposition are still standing.
  enemies: 'Enemies',
};
